<template>
    <div class="container">
        <div v-if="certificate === null" class="not-found-msg">
            <h3>{{ $t(`learning.progress.certificateNotFound`) }}</h3>
        </div>
        <div v-else>
            <div class="pdf-container">
                <vue-html2pdf
                    ref="html2Pdf"
                    :show-layout="true"
                    :float-layout="false"
                    :enable-download="true"
                    :preview-modal="false"
                    :pdf-quality="2"
                    :manual-pagination="true"
                    pdf-content-width="100%"
                    :html-to-pdf-options="{
                        enableLinks: true,
                        filename: `${certificate.pathName} Certificate.pdf`,
                        image: {
                            type: 'jpeg',
                            quality: 0.98,
                        },
                        html2canvas: {
                            scale: 2,
                            useCORS: true,
                        },
                        jsPDF: {
                            unit: 'in',
                            format: 'a5',
                            orientation: 'landscape',
                        },
                    }"
                >
                    <section slot="pdf-content">
                        <!-- PDF Content -->
                        <div class="certificate">
                            <div class="header pdf-item">
                                <div class="logo">
                                    <img alt="Leapsome Logo" :src="this.logo" />
                                </div>
                                <div class="header-right">
                                    <div class="company">
                                        {{ certificate.companyName }}
                                    </div>
                                    <div class="date">
                                        {{ certificate.completionDate }}
                                    </div>
                                </div>
                            </div>
                            <div class="content pdf-item">
                                <div class="name">{{ certificate.fullname }}</div>
                                <div class="completed">
                                    has successfully completed the Leapsome Learning Path
                                </div>
                                <div class="path-name">{{ certificate.pathName }}</div>
                            </div>
                            <div class="footer pdf-item">
                                <div class="certificate-id">
                                    Certificate ID: {{ certificate.certificateId }}
                                </div>
                                <div class="verification-link">
                                    <a
                                        :href="
                                            `https://www.leapsome.com/certificate/${certificate.certificateId}`
                                        "
                                    >
                                        https://www.leapsome.com/certificate/{{
                                            certificate.certificateId
                                        }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!--/ PDF Content -->
                    </section>
                </vue-html2pdf>
            </div>
            <div class="button-container">
                <button
                    class="btn btn-primary btn-framed btn-framed-primary"
                    @click="downloadPdf()"
                >
                    <i class="fa fa-download"></i>
                    Download as PDF
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import logo from "@/img/logo.svg";
import VueHtml2pdf from "vue-html2pdf";

export default {
    created() {
        this.logo = logo;
    },
    computed: {
        ...mapGetters({
            certificate: "learning/certificate/certificate",
        }),
    },
    methods: {
        downloadPdf() {
            this.$refs.html2Pdf.generatePdf();
        },
    },
    components: {
        VueHtml2pdf,
    },
};
</script>

<style scoped>
.not-found-msg {
    text-align: center;
    padding-top: 5rem;
}
.pdf-container {
    width: 769px;
    margin-left: auto;
    margin-right: auto;
}
.button-container {
    width: 769px;
    padding-top: 20px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.certificate {
    width: 100%;
    height: 550px;
    margin-left: auto;
    margin-right: auto;
    background-color: white;
    padding: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.header-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.company {
    font-weight: 500;
    font-size: 18px;
}

.content {
    display: flex;
    flex-direction: column;
    text-align: center;
}

.name {
    font-size: 25px;
    line-height: 50px;
    font-weight: 500;
}

.path-name {
    font-weight: 500;
    font-size: 30px;
    line-height: 50px;
}

.certificate-id {
    font-size: 1.3rem;
    color: rgb(160, 160, 160);
}

.verification-link {
    font-size: 1.3rem;
}
</style>
